import { render, staticRenderFns } from "./vt-tabbed-app-template.vue?vue&type=template&id=4c5c9385&scoped=true&"
import script from "./vt-tabbed-app-template.vue?vue&type=script&lang=ts&"
export * from "./vt-tabbed-app-template.vue?vue&type=script&lang=ts&"
import style0 from "./vt-tabbed-app-template.vue?vue&type=style&index=0&id=4c5c9385&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5c9385",
  null
  
)

export default component.exports